import * as React from "react";
import type { Action } from "../../reducer";

export type ContextType = {
  dispatch: (action: Action) => void;
};

const GameDispatchContext: React.Context<ContextType> = React.createContext<ContextType>({
  dispatch: () => {}
});

export default GameDispatchContext;
